import React from "react";
import { FormGroup, Label } from "reactstrap";
import { H4 } from "../../../../AbstractElements";

export default function NotesPermissions({ register, handleAll }) {
  return (
    <>
      {" "}
      <H4 attrH4={{ className: "mb-3 mt-2" }}>Notas</H4>
      <FormGroup className="m-t-15 m-checkbox-inline m-0">
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="list_note"
            type="checkbox"
            {...register("permissions.list_note", {})}
          />
          <Label for="list_note">
            {Option}
            <span className="digits"> Ver</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="create_note"
            type="checkbox"
            {...register("permissions.create_note", {})}
          />
          <Label for="create_note">
            {Option}
            <span className="digits"> Crear</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="edit_note"
            type="checkbox"
            {...register("permissions.edit_note", {})}
          />
          <Label for="edit_note">
            {Option}
            <span className="digits"> Modificar</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            className="p-0 m-0"
            id="delete_note"
            type="checkbox"
            {...register("permissions.delete_note", {})}
          />
          <Label for="delete_note">
            {Option}
            <span className="digits"> Eliminar</span>
          </Label>
        </div>
        <div className="form-check form-check-inline checkbox checkbox-dark mb-0">
          <input
            onChange={handleAll}
            className="p-0 m-0"
            id="note"
            type="checkbox"
          />
          <Label for="note">
            {Option}
            <span className="digits"> Todos</span>
          </Label>
        </div>
      </FormGroup>
    </>
  );
}
